import { useSafeAreaInsets } from "react-native-safe-area-context";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import React, { useContext, useEffect, useState } from "react";
import { useRoute } from "@react-navigation/native";
import WebView from "react-native-webview";
import { PlaceColors } from "./helpers/PlaceColors";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { FindifyNavigation } from "./components/FindifyNavigation";
import { getTranslatedString } from "./helpers/FindifyTranslatedString";


export const WebViewPage = ({ navigation }: any) => {
    const insets = useSafeAreaInsets();
    const router: any = useRoute();
    const [url, setUrl] = useState<string>('');
    const [title, setTitle] = useState<any>({});
    const findifyDataContext = useContext(FindifyDataContext);
    useEffect(() => {
        if (router?.params && router.params['url']) {
            setUrl(router?.params['url'] ?? '');
            setTitle(router?.params['title'] ?? {});
        }
    }, [router?.params])

    return (<>
        <FindifyTopBarOverlay />
        <FindifySimpleHeader
            hideMenu={router?.params['hideMenu'] ?? false}
            hideGoBack={router?.params['hideGoBack'] ?? false}
            navigation={navigation}
            title={getTranslatedString(title, findifyDataContext)}
        />
        <FindifyNavigation navigation={navigation} />
        <WebView
            // onLoadProgress={(e) => console.log(e)}
            onNavigationStateChange={(e) => {
                if (router && router.params != null && router.params['onNavigationStateChange']) {
                    router.params['onNavigationStateChange'](e, navigation)
                }
            }}
            source={{ uri: url }}
            style={{
                backgroundColor: PlaceColors(findifyDataContext).background.get(),
                flex: 1,
                marginBottom: insets.bottom,
            }}
        />
    </>);
};
